import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { SERVICES } from "../mock";
import Reveal from "./Reveal";

const Services = () => {
  return (
    <section id="services" className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 lg:py-32">
      <Reveal className="max-w-2xl mb-14">
        <p className="font-body text-sm text-[#2B4BFF] font-semibold mb-3">{SERVICES.kicker}</p>
        <h2 className="font-heading font-bold tracking-tight text-4xl sm:text-5xl leading-[1.05] text-[#0B1533]">
          {SERVICES.title}
        </h2>
        <p className="font-body text-[#5A607A] mt-5 text-lg">{SERVICES.subtitle}</p>
      </Reveal>

      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
        {SERVICES.items.map((item, i) => (
          <Reveal
            key={item.title}
            delay={i * 90}
            className="group relative rounded-3xl overflow-hidden h-80 cursor-pointer"
          >
            <img
              src={item.img}
              alt={item.title}
              loading="lazy"
              className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-700 ease-out"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#0B1533]/90 via-[#0B1533]/20 to-transparent" />
            <div className="absolute inset-0 p-6 flex flex-col justify-end">
              <h3 className="font-heading font-semibold text-xl text-white tracking-tight">
                {item.title}
              </h3>
              <p className="font-body text-sm text-white/80 mt-2 leading-relaxed">{item.desc}</p>
              <span className="mt-3 inline-flex items-center gap-1.5 font-body text-sm font-semibold text-white">
                Mehr erfahren <ArrowRight size={15} className="group-hover:translate-x-1 transition-transform duration-200" />
              </span>
            </div>
            <Link to={item.link} aria-label={item.title} data-testid={`service-tile-${i}`} className="absolute inset-0 z-10" />
          </Reveal>
        ))}
      </div>
    </section>
  );
};

export default Services;
